import { Typography } from '@mui/material';

import PhoneNumberLink from '../PhoneNumberLink';

import useFacilityStore from '@src/store/modules/facility.store';

export default function FurtherAssistanceContact() {
	const { facility } = useFacilityStore((store) => store);
	if (facility?.phoneNumber) {
		return (
			<Typography variant="bodySmallBook" color="primary.main">
				Need further assistance during business hours? Call{' '}
				<PhoneNumberLink phoneNumber={facility.phoneNumber} />
			</Typography>
		);
	}
}
